import React from 'react';
import '../css/homeStretch.css';

export class TakingOff extends React.Component {
	render() {
		return (
			<div>
				<div>
					<hr className="thin-horiz-line" />
				</div>

				<div className="homestretch-content">
					<div className="container-title">
						<h4>taking off</h4>
					</div>

					<div className="homestretch-text-container">
						<div className="homestretch-text">
							<a
								className="homestretch-link"
								href="https://www.kickstarter.com/projects/misenkitchen/misen-kickstarter-no4?ref=section-homepage-projectcollection-1-staff-picks-popular"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<img className="homestretch-image" src={require('../images/to-kitchen.jpg')} alt="" />
								{/* <button>
									<img className="heart" src={require('../images/svgexport-8.png')} alt="" />Remind Me
								</button> */}
								<br />
								Misen 2.0 - Essential Kitchen Tools Reimagined
							</a>

							<a
								className="link-no-underline"
								href="https://www.kickstarter.com/projects/misenkitchen/misen-kickstarter-no4?ref=section-homepage-projectcollection-1-staff-picks-popular"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<br />
								<p>
									Essential kitchen tools, reimagined. No gimmicks. No BS marketing claims. Just
									premium materials, thoughtful design and honest prices.
								</p>
							</a>
							<a
								className="black-link"
								href="https://www.kickstarter.com/projects/misenkitchen/misen-kickstarter-no4?ref=section-homepage-projectcollection-1-staff-picks-popular"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<br />
								By <span className="name-underline">Misen</span>
							</a>
						</div>

						<div className="homestretch-text">
							<a
								className="homestretch-link"
								href="https://www.kickstarter.com/projects/nichtlustig/moviecliches?ref=section-homepage-projectcollection-2-staff-picks-popular"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<img
									className="homestretch-image"
									src={require('../images/ff-movie.png')}
									alt=""
								/>{' '}
								<br />
								MOVIE CLICHÉS - the card game
							</a>

							<a
								className="link-no-underline"
								href="https://www.kickstarter.com/projects/nichtlustig/moviecliches?ref=section-homepage-projectcollection-2-staff-picks-popular"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<br />
								<p>A card game made by (bad) movies.</p>
							</a>
							<a
								className="black-link"
								href="https://www.kickstarter.com/projects/nichtlustig/moviecliches?ref=section-homepage-projectcollection-2-staff-picks-popular"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<br />
								By <span className="name-underline">Joscha Sauer</span>
							</a>
						</div>

						<div className="homestretch-text">
							<a
								className="homestretch-link"
								href="https://www.kickstarter.com/projects/rockfishgames/everspace-2?ref=section-homepage-projectcollection-3-staff-picks-popular"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<img
									className="homestretch-image"
									src={require('../images/to-everspace.jpg')}
									alt=""
								/>{' '}
								<br />
								EVERSPACE 2
							</a>

							<a
								className="link-no-underline"
								href="https://www.kickstarter.com/projects/rockfishgames/everspace-2?ref=section-homepage-projectcollection-3-staff-picks-popular"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<br />
								<p>
									An open-world space shooter with deep exploration, sophisticated RPG elements and an
									engaging sci-fi story; the sequel to EVERSPACE.
								</p>
							</a>
							<a
								className="black-link"
								href="https://www.kickstarter.com/projects/rockfishgames/everspace-2?ref=section-homepage-projectcollection-3-staff-picks-popular"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<br />
								By <span className="name-underline">ROCKFISH Games</span>
							</a>
						</div>

						<div className="homestretch-text">
							<a
								className="homestretch-link"
								href="https://www.kickstarter.com/projects/1162110258/time-of-legends-joan-of-arc-15?ref=section-homepage-projectcollection-4-staff-picks-popular"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<img
									className="homestretch-image"
									src={require('../images/to-legends.jpg')}
									alt=""
								/>{' '}
								<br />
								Time of Legends: Joan of Arc 1.5
							</a>

							<a
								className="link-no-underline"
								href="https://www.kickstarter.com/projects/1162110258/time-of-legends-joan-of-arc-15?ref=section-homepage-projectcollection-4-staff-picks-popular"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<br />
								<p>
									The legendary game is back! Relive the golden age of chivalry in this 2-4 player
									scenario-based board game of medieval battle and myth.
								</p>
							</a>

							<a
								className="black-link"
								href="https://www.kickstarter.com/projects/1162110258/time-of-legends-joan-of-arc-15?ref=section-homepage-projectcollection-4-staff-picks-popular"
								rel="noopener  noreferrer"
							>
								<br />
								By <span className="name-underline">Mythic Games, Inc.</span>
							</a>
						</div>

						<div className="homestretch-text">
							<a
								className="homestretch-link"
								href="https://www.kickstarter.com/projects/1874428722/printpen-portable-printer-for-all-materials-and-surfaces?ref=section-homepage-projectcollection-5-staff-picks-popular"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<img
									className="homestretch-image"
									src={require('../images/to-printpen.jpg')}
									alt=""
								/>{' '}
								<br />
								PrintPen: Portable Printer for all Materials and Surfaces
							</a>

							<a
								className="link-no-underline"
								href="https://www.kickstarter.com/projects/1874428722/printpen-portable-printer-for-all-materials-and-surfaces?ref=section-homepage-projectcollection-5-staff-picks-popular"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<br />
								<p>
									A pocket-size tool that allows you to transfer your ideas from your head to the real
									world anytime, anywhere.
								</p>
							</a>
							<a
								className="black-link"
								href="https://www.kickstarter.com/projects/1874428722/printpen-portable-printer-for-all-materials-and-surfaces?ref=section-homepage-projectcollection-5-staff-picks-popular"
								target="_blank"
								rel="noopener  noreferrer"
							>
								<br />
								By <span className="name-underline">EVEBOT</span>
							</a>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
